import React from "react";
import styled from "styled-components";

export const SectionHeading = styled.h3`
    margin-top: 1rem;
`;
